import { basierCirleBold } from "@/styles/fonts";
import theme from "@/styles/theme";
import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";

export const ModalStyled = ({
  children,
  open,
  onClose,
  disableCloseOnBackgroundClick = false,
  type = "", // "fullScreen", "dark" or empty
  ...props
}) => {
  const handleClose = () => {
    if (onClose && typeof onClose === "function") {
      onClose();
    }
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={disableCloseOnBackgroundClick ? null : handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
        sx: {
          backgroundColor: "rgba(0, 0, 0, 0.75)",
        },
      }}
    >
      <Fade in={open}>
        <Box sx={modalStyles(type)}>
          <IconButton
            size="large"
            aria-label="Schließen"
            onClick={handleClose}
            className="close-button"
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
          {children}
        </Box>
      </Fade>
    </Modal>
  );
};

const modalStyles = (type) => ({
  position: "absolute",
  top: type === "fullScreen" ? "0" : "50%",
  left: type === "fullScreen" ? "0" : "50%",
  transform:
    type === "fullScreen" ? "translate(0, 0)" : "translate(-50%, -50%)",
  width: type === "fullScreen" ? "100%" : 290,
  height: type === "fullScreen" ? "100%" : "auto",
  backgroundColor:
    type === "fullScreen"
      ? "transparent"
      : type === "dark"
        ? theme.palette.common.black
        : theme.palette.common.white,
  boxShadow: 24,
  padding: "1.5rem",
  [theme.breakpoints.up("sm")]: {
    width: type === "fullScreen" ? "100%" : 500,
  },
  [theme.breakpoints.up("md")]: {
    width: type === "fullScreen" ? "100%" : 800,
  },
  "& .MuiTypography-root": {
    "& span": {
      fontWeight: basierCirleBold.style.fontWeight,
      fontFamily: basierCirleBold.style.fontFamily,
    },
  },
  "& .modal": {
    "&--buttons": {
      mt: 4,
    },
  },
  "& .MuiIconButton-root.close-button": {
    position: "absolute",
    top: 0,
    right: 0,
    transform: "translate(-.25rem, .25rem)",
    color:
      type === "dark" ? theme.palette.common.white : theme.palette.common.black,
  },
});
